/**
 * Playready Recommendation Key System.
 *
 * @group DRM
 *
 * @beta
 */
export const PLAYREADY_RECOMMENDATION_KEY_SYSTEM = 'com.microsoft.playready.recommendation';
